import { useDispatch, useSelector } from "react-redux";
import { setNotifTo } from "../../store";
import { useEffect } from "react";

function Notification() {
  const dispatch = useDispatch();
  const { notifText } = useSelector((state) => state.app);

  useEffect(() => {
    notifText &&
      setTimeout(() => {
        notifText && dispatch(setNotifTo(null));
      }, 2700);
  }, [dispatch, notifText]);

  if (!notifText) return null;

  return (
    <div className="fixed bg-[#0000007a] h-max rounded-xl text-xs left-0 right-0 mx-auto top-[80px] z-50 text-white text-center py-1 pm-notif-anim">
      {notifText}
    </div>
  );
}

export default Notification;
